<template>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12 sm8 md4>
                <v-card class='elevation-2 animated fadeIn'>
                    <v-form v-model="valid" id="input-form" name="input-form" ref="form" action='/Account/ApplicationLogin' method='post' enctype='application/x-www-form-urlencoded' v-on:submit.prevent='submit' autocomplete="off">
                        <v-toolbar flat>
                            <v-toolbar-title>Iniciar Sesión</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-text-field v-model='UserName'
                                          name='UserName'
                                          type='text'
                                          prepend-icon='person'
                                          label='Nombre de Usuario'
                                          :rules="[v => !!v || 'El Nombre de Usuario es requerido']"></v-text-field>
                            <v-text-field v-model='Password'
                                          name='Password'
                                          type='password'
                                          prepend-icon='lock'
                                          label='Contraseña'
                                          :rules="[v => !!v || /\s/.test(v) || 'La Contraseña es requerido']"></v-text-field>
                            <v-checkbox v-model='RememberMe'
                                        name='RememberMe'
                                        label='Recuérdame'
                                        type='checkbox'></v-checkbox>
                            <v-btn to="forgotPassword" color="primary" flat>Olvide mi Contraseña</v-btn>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn type='submit'><v-icon>done</v-icon>Ingresar</v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-form>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import script from './script'
    export default script
</script>



// WEBPACK FOOTER //
// src/components/account/login/component.vue